/** Auto-generated by scripts/build-package.mjs — do not edit. */

import PhysicsSystem from './PhysicsSystem';

Object.assign(PhysicsSystem, {
  packageName: "@combos-fun/plugin-matterjs",
  packageVersion: "0.0.39",
});
